import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Form } from "antd";
import FormItem from "../../../FormItem";
import { getAnswerColor } from "../../../../../helpers/utils";

const CSFAnswerModule = ({
  questionData: qn,
  setVisibleQnIds,
  isAdminView,
  setAnswer,
}) => {
  const [form] = Form.useForm();
  const [fieldError, setFieldError] = useState([]);
  const previousAnswer = qn?.answer;

  const { submitLoading } = useSelector((state) => state.CSFSurvey);

  const handleOnChange = (answer) => {
    setAnswer(answer, previousAnswer);
  };

  // Admin view display logic
  if (isAdminView) {
    const optedAnswer = previousAnswer?.opted_answer;
    const optedAnswerText = previousAnswer?.opted_answer_text; // (only if "Other" selected)

    const displayText = optedAnswerText
      ? `Other: ${optedAnswerText || "Not Answered"}`
      : optedAnswer || "Not Answered";

    return (
      <div
        className="smiley-container response-text"
        style={{ color: getAnswerColor(optedAnswer) }}
      >
        {displayText}
      </div>
    );
  }

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={() => {}}
      autoComplete="off"
      validateTrigger="onBlur"
      scrollToFirstError
      onFinishFailed={() => {}}
    >
      <FormItem
        key={qn?.id}
        inputType={qn?.component?.type}
        className={`preassessment-field ${
          fieldError.includes(qn?.id) ? "error" : ""
        }`}
        name={qn?.id}
        rules={[
          {
            required: qn?.required,
            message: qn?.required_text || "Please fill the field to proceed!",
          },
        ]}
        placeholderText={qn?.placeholder}
        options={
          qn?.options?.map((opn) => ({
            value: opn.id,
            name: opn.option,
            option_has_text: opn?.option_has_text,
          })) || []
        }
        answer={qn?.answer || qn?.answers}
        onChange={handleOnChange}
        qnId={qn?.id}
        form={form}
        setError={{ fieldError, setFieldError }}
        required={qn?.required}
        setVisibleQnIds={qn?.has_linked_question ? setVisibleQnIds : () => {}}
        customStyles={{ width: "30vw" }}
        showQn={false}
        showSmiley={true}
        disabled={isAdminView}
        other_placeholder={qn?.other_option_placeholder}
        loading={submitLoading}
      />
    </Form>
  );
};

export default CSFAnswerModule;
